import React, { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import { useLoginContext } from "./LoginContext"

interface SearchContextType {
  searchKeyword: string
  setSearchKeyword: (searchKeyword: string) => void
}

export const SearchContext = React.createContext<SearchContextType | undefined>(undefined)
SearchContext.displayName = "SearchContext"

export const SearchContextProvider: React.FC<React.PropsWithChildren> = (props) => {
  const location = useLocation()
  const { realGroupId, regionCode } = useLoginContext()
  const [searchKeyword, setSearchKeyword] = useState<string>()

  useEffect(() => {
    setSearchKeyword("")
  }, [])

  useEffect(() => {
    setSearchKeyword("")
  }, [realGroupId, regionCode])

  useEffect(() => {
    setSearchKeyword("")
  }, [location])

  return (
    <SearchContext.Provider
      value={{
        searchKeyword,
        setSearchKeyword,
      }}
    >
      {props.children}
    </SearchContext.Provider>
  )
}

export const useSearchContext = () => React.useContext<SearchContextType>(SearchContext)
